import React from 'react';
import { arrayOf, bool, func, number, shape, string } from 'prop-types';
import { I18n as I } from 'react-redux-i18n';
import { AutoComplete } from 'antd';
import { debounce } from 'lib/Utils';

const getGarageLabel = garage =>
  !garage
    ? ''
    : `${garage.DistinctiveTitle}, ${garage.Street} ${garage.StreetNumber}, ${garage.City}`;

const GarageSelection = ({
  allowCreation,
  fetching,
  garages,
  onAdvance,
  onClearGarages,
  onSearchGarages,
  onUpdateGarageData,
  selectedGarage,
}) => {
  const [searchTerm, setSearchTerm] = React.useState('');

  const options = React.useMemo(
    () =>
      (garages || []).map(garage => ({
        label: getGarageLabel(garage),
        value: garage.ID,
      })),
    [garages]
  );

  const handleSearch = React.useMemo(
    () => debounce(value => value && onSearchGarages(value), 300),
    [onSearchGarages]
  );

  const handleSelect = React.useCallback(
    value => {
      setSearchTerm('');
      onUpdateGarageData(garages.find(g => g.ID === value));
    },
    [garages, onUpdateGarageData]
  );

  React.useEffect(() => {
    if (!searchTerm) onClearGarages();
  }, [searchTerm]); //eslint-disable-line

  const currentLabel = getGarageLabel(selectedGarage);

  return (
    <div>
      <div className="note note-info">{I.t('IF_INSERTED_GARAGE')}</div>
      <div className="row">
        <label className="col-md-4 control-label">
          {I.t('GARAGE_TAX_NUMBER')}
        </label>
        <div className="col-md-8">
          <AutoComplete
            onChange={setSearchTerm}
            onSelect={handleSelect}
            onSearch={handleSearch}
            options={options}
            style={{ width: '100%' }}
            value={searchTerm || currentLabel}
          />
        </div>
      </div>
      <hr />
      <div>
        {!selectedGarage ? (
          allowCreation && (
            <button
              type="button"
              className="btn btn-sm btn-primary float-right"
              onClick={onAdvance}
            >
              {I.t('GARAGE_CREATE')}
            </button>
          )
        ) : (
          <div className="note note-info">
            <button
              type="button"
              className="close"
              onClick={() => onUpdateGarageData(null)}
            />
            <div>
              <span className="bold">{selectedGarage.DistinctiveTitle}</span>
              <br />
              {selectedGarage.Street} {selectedGarage.StreetNumber},{' '}
              {selectedGarage.City}
            </div>
          </div>
        )}
      </div>
      <div className="clear" />
    </div>
  );
};

const garagePropType = shape({
  City: string,
  DistinctiveTitle: string,
  ID: number,
  Street: number,
  StreetNumber: string,
});
GarageSelection.propTypes = {
  allowCreation: bool,
  fetching: bool,
  garages: arrayOf(garagePropType),
  onAdvance: func.isRequired,
  onClearGarages: func.isRequired,
  onSearchGarages: func.isRequired,
  onUpdateGarageData: func.isRequired,
  selectedGarage: garagePropType,
};

export default GarageSelection;
